import { Injectable } from '@angular/core';
import { Job, JobDatService } from '../job';
import { Order, OrderJob } from './order-types';
import { firstValueFrom, Observable } from 'rxjs';
import { DateUtilsService } from 'src/app/services/date-utils.service';


@Injectable({
    providedIn: 'root'
}) 
export class OrderData {
    constructor(
        private jobData: JobDatService,
        private dateUtils: DateUtilsService,
    ) {
    }

    public async orderFromId(orderId: number){
        const orderJobs = await firstValueFrom<Job[]>(this.jobData.getJobsByOrderId$(orderId));
        const minJobInOrder = orderJobs.find(cj => cj.id === Math.min(...orderJobs.map(j=>j.id)));

        const order: Order = {
            orderId: minJobInOrder.orderId,
            defaultScheduledDate: minJobInOrder.scheduling.itinerary.date,
            orderNumber: minJobInOrder.customerPOnum || '',
            items: this.getOrderItemsFromJobs(orderJobs, minJobInOrder.id),
            address: minJobInOrder.address,
            customer: minJobInOrder.customer,
            openingTime: minJobInOrder.openingTime,
            closingTime: minJobInOrder.closingTime,
            notes: minJobInOrder.notes,
            vip: minJobInOrder.vip,
            jobs: orderJobs.map(j=>this.getOrderJobFromJob(j, j.id===minJobInOrder.id))
        }
        return order;
    }

    public async orderFromJob(job: Job){
        return await this.orderFromId(job.orderId);
    }

    private getOrderItemsFromJobs(jobs: Job[], minJobId: number): Order['items']{
        const itemsWithJob = jobs.map(j=>j.items.map(i=>{return {...i, job: j}})).flat();
        return itemsWithJob.reduce((itemsMerged, jobItem) => {
            const jobSubitem = jobItem.type==='S' && jobItem.subItems?.length>0 ? jobItem.subItems[0] : { sku: '', description: '', quantity: 1, serialNumber: '', jobDetailId: 0};
            const item = {
                id: jobSubitem.jobDetailId || 0,
                sku: jobSubitem.sku,
                description: jobSubitem.description,
                serialNumber: jobSubitem.serialNumber,
                quantity: jobSubitem.quantity,
                services: []
            }
            if(!itemsMerged.some(i=>i.sku === item.sku && i.id === item.id)){
                itemsMerged.push(item);
            }
            item.services = itemsWithJob
                .filter(jobItem=>jobItem.type==='S' && jobItem.subItems?.length>0 && jobItem.subItems[0].sku === item.sku && jobItem.subItems[0].jobDetailId === item.id)
                .map(jobItem=>{
                    return {
                        id: jobItem.jobDetailId,
                        name: jobItem.sku,
                        description: jobItem.description,
                        job: this.getOrderJobFromJob(jobItem.job, jobItem.job.id === minJobId),
                        isInstall: jobItem.installation
                    }
            });
            return itemsMerged;
        }, [])
    }

    private getOrderJobFromJob(job: Job, isMain): OrderJob{
        return {
            id: job.id,
            scheduledDate: job.scheduling.itinerary.date,
            serviceTime: job.serviceTime,
            preferredStart: this.dateUtils.formatDate(job.scheduling.preferences.time_window.start.toDate(), 'HH:mm'),
            preferredEnd: this.dateUtils.formatDate(job.scheduling.preferences.time_window.end.toDate(), 'HH:mm'),
            thirdMan: job.thirdMan,
            coordinated: job.coordinated,
            sequence: job.sequence,
            isMain
        }
    }

    public async getSkus(name: string): Promise<Observable<{name: string, description: string}[]>>{
        return await this.jobData.getSkus(name);
    }

}


